import React, { useEffect, useState } from 'react';
import './eyetestList.scss';
import {
    Badge,
    Button,
    ButtonGroup,
    Card,
    Container,
    Dropdown,
    Form,
    Image,
    Modal,
    Stack,
    Table,
} from 'react-bootstrap';
import edit from '../../Assets/Img/edit.png';
import view from '../../Assets/Img/eye.png';
import NoDraft from '../../Assets/Img/noDrafts.png';
import { useSelector } from 'react-redux';
import {
    useAssignTestToDocMutation,
    useEyetestListMutation,
} from './eyetestApi';
import { useLocation, useNavigate } from 'react-router';
import { Eye, File, Pencil, Plus, CircleAlert } from 'lucide-react';
import LoadingComponent from '../LoadingComponent';
import { useTranslation } from 'react-i18next';
import { formatDate, frenchFormatDate, toCamelCase } from '../../helper';
import AssignDoc from './assignDoc';
import Notify from './notify';
import ExportExcel from './exportExcel';
import DeleteUser from '../Profile/deleteUser';
import { FaBolt } from 'react-icons/fa6';
import { setSecureItem, getSecureItem, removeSecureItem } from "../../utils/secureStorage";
import { getSecureSessionItem } from "../../utils/secureSessionStorage";
const EyetestList = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    console.log('state =======================> ', state);
    console.log(state?.status ? 'state?.status' : '0', 'statestate');

    const user = getSecureItem('UserData');
    const iSContactLense = getSecureItem('ContactLense');
    const navigate = useNavigate();
    const eyetestData = useSelector((state) => state.eyetest);
    console.log(
        'eyetestDataeyetestDataeyetestDataeyetestDataeyetestDataeyetestDataeyetestDataeyetestDataeyetestDataeyetestDataeyetestDataeyetestDataeyetestDataeyetestData ==== > ',
        eyetestData
    );
    const [loading, setLoading] = useState(true);
    const config = {
        eyeTestId: '',
        patientEmail: '',
        status:
            state?.status == 'approved'
                ? 'Approved'
                : state?.status == 'pendingValidation' ||
                    state?.status == 'unassigned' ||
                    state?.status == 'assigned'
                    ? 'New'
                    : state?.status == 'notApproved'
                        ? 'Not Approved'
                        : '',
        search: '',
        latestRecords: 0,
        pageSize: 50,
        pageNumber: 1,
        startDate: '',
        endDate: '',
        assigUnassigned:
            state?.status == 'pendingValidation'
                ? '1'
                : state?.status == 'unassigned'
                    ? '0'
                    : '',
    };

    // const [pageCount, setPageCount] = useState(state?.pageCount || 1);
    const [pageCount, setPageCount] = useState(() => {
        let pageCountValue = getSecureSessionItem("pageCount");

        return pageCountValue ? pageCountValue.eyetest : 1;
    });
    const [idSum, setIdSum] = useState([]);
    // const [eyetestListConfig, seteyetestListConfig] = useState(config);
    const [eyetestListConfig, seteyetestListConfig] = useState(() => {
        const saved =
            getSecureItem('eyeTestListConfigCopy') || config;
        return saved ? saved : config;
    });
    useEffect(() => {
        console.log('eyetestListConfig =====> ', eyetestListConfig);
    }, [eyetestListConfig]);
    const [eyetestList] = useEyetestListMutation();

    useEffect(() => {
        if (!loading) return;

        const finalConfig = {
            ...eyetestListConfig,
            patientEmail: state?.fromPatient
                ? state?.email
                : eyetestListConfig.patientEmail,
        };

        eyetestList(finalConfig).then(() => {
            setLoading(false);
        });

    }, [loading, state]);

    const handleFilterChange = (count = 1) => {
        setSecureItem(
            'eyeTestListConfigCopy', eyetestListConfig
        );
        setPageCount(count);
        seteyetestListConfig({ ...eyetestListConfig, pageNumber: count });
        setLoading(true);
    };

    const handleChange = (e) => {
        seteyetestListConfig((prevValues) => {
            return {
                ...prevValues,
                [e.target.name]: e.target.value,
            };
        });
    };

    const handleIdSum = (checked, id) => {
        console.log(checked, id, 'checked, id');
        let array = idSum;
        const index = array.indexOf(id);
        if (checked) {
            // Add ID if not already in the array
            if (index === -1) {
                array.push(id);
            }
        } else {
            // Remove ID if it exists in the array
            if (index !== -1) {
                array.splice(index, 1);
            }
        }
        setIdSum([...array]);
    };

    if (loading) {
        return <LoadingComponent />;
    }

    const eyeTestHigtlightStyle = {
        backgroundColor: '#EBEFFE',
    };

    return (
        <>
            <Container fluid className="list_wrapper">
                {['OPTICIAN', 'BACKOFFICE', 'ADMIN'].includes(
                    user?.userType
                ) && (
                        <Stack
                            direction="horizontal"
                            gap={3}
                            className="mb-3"
                            style={
                                {
                                    // border: "2px solid red"
                                }
                            }
                        >
                            <div
                                className="ms-auto"
                                style={{
                                    // border: "2px solid blue",
                                    width: '100%',
                                }}
                            >
                                <Stack
                                    direction="horizontal"
                                    gap={3}
                                    className="mb-3"
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-evenly",
                                        alignItems: "flex-end",
                                        flexDirection: "column-reverse",
                                        flexWrap: "wrap",
                                        alignContent: "stretch",
                                    }}
                                >
                                    <div className="d-none">
                                        {['ADMIN', 'BACKOFFICE'].includes(user?.userType) && (
                                            <ExportExcel status={state?.status} />
                                        )}
                                    </div>
                                    <Dropdown>
                                        <Dropdown.Toggle
                                            variant="primary"
                                            id="dropdown-basic"
                                            disabled={user?.userType == 'PATIENT'}
                                        >
                                            <Plus width={14} height={14} />{' '}
                                            {t('addNewEyetest')}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item
                                                onClick={() =>
                                                    navigate('/eyetest/add', {
                                                        state: {
                                                            glass: true,

                                                            // ✅ Forward patient data if coming from profile
                                                            fromPatient: state?.fromPatient,
                                                            patientEmail: state?.email,
                                                            name: state?.name,
                                                            lastName: state?.lastName,
                                                        },
                                                    })
                                                }
                                            >
                                                {t('glasses')}
                                            </Dropdown.Item>
                                            {iSContactLense === false ? null : (
                                                <Dropdown.Item
                                                    onClick={() =>
                                                        navigate('/eyetest/add', {
                                                            state: {
                                                                glass: false,

                                                                fromPatient: state?.fromPatient,
                                                                patientEmail: state?.email,
                                                                name: state?.name,
                                                                lastName: state?.lastName,
                                                            },
                                                        })
                                                    }
                                                >
                                                    {t('lenses')}
                                                </Dropdown.Item>
                                            )}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Stack>
                            </div>
                            <div className="mb-3">
                                {['pendingValidation', 'unassigned'].includes(
                                    state?.status
                                ) &&
                                    ['ADMIN', 'BACKOFFICE'].includes(
                                        user?.userType
                                    ) &&
                                    !user?.isExternal && (
                                        <AssignDoc
                                            idSum={idSum}
                                            setLoading={setLoading}
                                            onClearSelection={() => setIdSum([])}
                                        />
                                    )}
                                {['approved'].includes(state?.status) &&
                                    ['ADMIN', 'BACKOFFICE'].includes(user?.userType) && (
                                        <Notify
                                            idSum={idSum}
                                            setLoading={setLoading}
                                        />
                                    )}
                            </div>
                        </Stack>
                    )}

                <Card>
                    {/* {!state?.email ? (
                        user?.userType !== 'PATIENT' ? (
                            <Card.Header>
                                <Stack
                                    direction="horizontal"
                                    gap={3}
                                    className="listing_filters"
                                >
                                    <Stack direction="horizontal" gap={3}>
                                        <Form.Control
                                            type="text"
                                            onChange={handleChange}
                                            value={eyetestListConfig.search}
                                            name="search"
                                            placeholder={t('search')}
                                        />
                                        <Form.Control
                                            type="date"
                                            onChange={handleChange}
                                            name="startDate"
                                        />
                                        <Form.Control
                                            type="date"
                                            onChange={handleChange}
                                            name="endDate"
                                        />
                                        <Button
                                            variant="secondary"
                                            onClick={() => handleFilterChange()}
                                        >
                                            {t('search')}
                                        </Button>
                                    </Stack>
                                    <div className="ms-auto">
                                        <Button
                                            variant="link"
                                            className=""
                                            onClick={() => {
                                                seteyetestListConfig(config);
                                                setLoading(true);
                                            }}
                                        >
                                            {t('resetFilters')}
                                        </Button>
                                    </div>
                                </Stack>
                            </Card.Header>
                        ) : (
                            ''
                        )
                    ) : (
                        ''
                    )} */}

                    <Card.Header>
                        <Stack
                            direction="horizontal"
                            gap={3}
                            className="listing_filters"
                        >
                            <Stack direction="horizontal" gap={3}>
                                <Form.Control
                                    type="text"
                                    onChange={handleChange}
                                    value={eyetestListConfig.search}
                                    name="search"
                                    placeholder={t('search')}
                                />
                                <Form.Control
                                    type="date"
                                    onChange={handleChange}
                                    name="startDate"
                                />
                                <Form.Control
                                    type="date"
                                    onChange={handleChange}
                                    name="endDate"
                                />
                                <Button
                                    variant="secondary"
                                    onClick={() => handleFilterChange()}
                                >
                                    {t('search')}
                                </Button>
                                <div className="">
                                    {['ADMIN', 'BACKOFFICE'].includes(user?.userType) && (
                                        <ExportExcel
                                            status={state?.status}
                                            startDate={eyetestListConfig.startDate}
                                            endDate={eyetestListConfig.endDate}
                                        />
                                    )}
                                </div>
                            </Stack>
                            <div className="ms-auto">
                                <Button
                                    variant="link"
                                    className=""
                                    onClick={() => {
                                        seteyetestListConfig(config);
                                        setLoading(true);
                                    }}
                                >
                                    {t('resetFilters')}
                                </Button>
                            </div>
                        </Stack>
                    </Card.Header>

                    <Card.Body className="table_outer">
                        <Table>
                            <thead>
                                <tr>
                                    {['BACKOFFICE', 'ADMIN'].includes(
                                        user?.userType
                                    ) ? (
                                        <th></th>
                                    ) : null}
                                    <th>N° Test</th>
                                    {user?.userType != 'EYEDOCTOR' && (
                                        <th>{t('optician')}</th>
                                    )}
                                    {user?.userType != 'EYEDOCTOR' && (
                                        <th>{t('pdv')}</th>
                                    )}
                                    <th>{t('patient')}</th>
                                    <th>{t('createdOn')}</th>
                                    <th>{t('type')}</th>
                                    {['BACKOFFICE', 'ADMIN'].includes(
                                        user?.userType
                                    ) ||
                                        ['Approved', 'Not Approved'].includes(
                                            state?.status
                                        ) ? (
                                        <th>{t('Docteur')}</th>
                                    ) : null}
                                    <th>{t('status')}</th>
                                    <th className="text-end">{t('actions')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {eyetestData?.listData?.eyeTestData &&
                                    eyetestData?.listData?.eyeTestData.length >
                                    0 ? (
                                    eyetestData?.listData?.eyeTestData.map(
                                        (eyetest, index) => {
                                            console.log(
                                                `eyetest ${index + 1} ==== `,
                                                eyetest
                                            );
                                            console.log(
                                                `assignedToDoc Value ${index + 1} ==== `,
                                                eyetest.assignedToDoc
                                            );
                                            return (
                                                <tr key={index}>
                                                    {[
                                                        'BACKOFFICE',
                                                        'ADMIN',
                                                    ].includes(
                                                        user?.userType
                                                    ) ? (
                                                        <td
                                                            style={
                                                                eyetest.isExpressTest
                                                                    ? eyeTestHigtlightStyle
                                                                    : undefined
                                                            }
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    handleIdSum(
                                                                        e.target
                                                                            .checked,
                                                                        eyetest.testId
                                                                    );
                                                                }}
                                                            />
                                                        </td>
                                                    ) : null}
                                                    <td
                                                        style={
                                                            eyetest.isExpressTest
                                                                ? eyeTestHigtlightStyle
                                                                : undefined
                                                        }
                                                    >
                                                        {eyetest.testUniqueCode}
                                                    </td>
                                                    {user?.userType !=
                                                        'EYEDOCTOR' && (
                                                            <td
                                                                style={
                                                                    eyetest.isExpressTest
                                                                        ? eyeTestHigtlightStyle
                                                                        : undefined
                                                                }
                                                            >
                                                                {
                                                                    eyetest.opticianName
                                                                }
                                                            </td>
                                                        )}
                                                    {user?.userType !=
                                                        'EYEDOCTOR' && (
                                                            <td
                                                                style={
                                                                    eyetest.isExpressTest
                                                                        ? eyeTestHigtlightStyle
                                                                        : undefined
                                                                }
                                                            >
                                                                {eyetest.posName}
                                                            </td>
                                                        )}
                                                    <td
                                                        style={
                                                            eyetest.isExpressTest
                                                                ? eyeTestHigtlightStyle
                                                                : undefined
                                                        }
                                                    >
                                                        {eyetest.patientName}
                                                    </td>
                                                    <td
                                                        style={
                                                            eyetest.isExpressTest
                                                                ? eyeTestHigtlightStyle
                                                                : undefined
                                                        }
                                                    >
                                                        {frenchFormatDate(
                                                            eyetest.createDate
                                                        )}
                                                    </td>
                                                    <td
                                                        style={
                                                            eyetest.isExpressTest
                                                                ? eyeTestHigtlightStyle
                                                                : undefined
                                                        }
                                                    >
                                                        {eyetest.testType ===
                                                            'EyeGlasses' ? (
                                                            <Badge className="eye_badge glasses">
                                                                {t('glasses')}
                                                            </Badge>
                                                        ) : (
                                                            <Badge className="eye_badge lenses">
                                                                {t('lenses')}
                                                            </Badge>
                                                        )}
                                                    </td>
                                                    {[
                                                        'BACKOFFICE',
                                                        'ADMIN',
                                                    ].includes(
                                                        user?.userType
                                                    ) &&
                                                        (eyetest?.status ===
                                                            'New' ? (
                                                            <td
                                                                style={
                                                                    eyetest.isExpressTest
                                                                        ? eyeTestHigtlightStyle
                                                                        : undefined
                                                                }
                                                            >
                                                                {eyetest.assignedToDoc ===
                                                                    'Yes'
                                                                    ? eyetest.doctorName
                                                                    : ''}
                                                            </td>
                                                        ) : (
                                                            <td
                                                                style={
                                                                    eyetest.isExpressTest
                                                                        ? eyeTestHigtlightStyle
                                                                        : undefined
                                                                }
                                                            >
                                                                {eyetest.doctorName &&
                                                                    eyetest.doctorName !=
                                                                    ' '
                                                                    ? eyetest.doctorName
                                                                    : 'N/A'}
                                                            </td>
                                                        ))}

                                                    <td
                                                        style={
                                                            eyetest.isExpressTest
                                                                ? eyeTestHigtlightStyle
                                                                : undefined
                                                        }
                                                    >
                                                        <Badge
                                                            className="status_badge"
                                                            style={{
                                                                position:
                                                                    'relative',
                                                            }}
                                                        >
                                                            {t(
                                                                toCamelCase(
                                                                    eyetest.status
                                                                )
                                                            )}
                                                            {/* {eyetest.isExpressTest && (
                                                                <div style={{
                                                                    position: "absolute",
                                                                    color: "white",
                                                                    backgroundColor: "#e2cc01ff",
                                                                    borderRadius: "100%",
                                                                    rotate: "15deg",
                                                                    top: -16,
                                                                    right: -12,
                                                                }}>
                                                                    <FaBolt style={{
                                                                        margin: 5,
                                                                        color: "white",
                                                                        height: 10,
                                                                        width: 10,
                                                                    }} />
                                                                </div>
                                                            )} */}

                                                            {eyetest.isExpressTest && user?.userType !== 'PATIENT' && (
                                                                <img
                                                                    src="/flash.png"
                                                                    alt="Express Test"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        color: 'white',
                                                                        borderRadius: '100%',
                                                                        top: -8,
                                                                        right: -5,
                                                                    }}
                                                                />
                                                            )}
                                                        </Badge>
                                                    </td>
                                                    <td
                                                        style={
                                                            eyetest.isExpressTest
                                                                ? eyeTestHigtlightStyle
                                                                : undefined
                                                        }
                                                    >
                                                        <Stack
                                                            direction="horizontal"
                                                            gap={1}
                                                        >
                                                            <div className="ms-auto">
                                                                <ButtonGroup>
                                                                    {eyetest?.status ===
                                                                        'Approved' &&
                                                                        eyetest?.needPrescription ===
                                                                        'Yes' && (
                                                                            <div className="ms-auto">
                                                                                {(user?.userType ===
                                                                                    'EYEDOCTOR' ||
                                                                                    user?.userType ===
                                                                                    'PATIENT' ||
                                                                                    user?.userType ===
                                                                                    'BACKOFFICE' ||
                                                                                    user?.userType ===
                                                                                    'ADMIN' ||
                                                                                    (user?.userType ===
                                                                                        'OPTICIAN' &&
                                                                                        eyetest?.showPrescriptiontoOptician ===
                                                                                        'Yes')) && (
                                                                                        <Button
                                                                                            variant="light"
                                                                                            onClick={() =>
                                                                                                navigate(
                                                                                                    '/prescription',
                                                                                                    {
                                                                                                        state: {
                                                                                                            id: eyetest.testId,
                                                                                                        },
                                                                                                    }
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            <Stack
                                                                                                direction="horizontal"
                                                                                                gap={
                                                                                                    1
                                                                                                }
                                                                                            >
                                                                                                {/* <img src={edit} width={16} /> */}
                                                                                                <File
                                                                                                    width={
                                                                                                        16
                                                                                                    }
                                                                                                />
                                                                                                {/* <span style={{ color: "#1D2939" }}> {t("prescription")}</span> */}
                                                                                            </Stack>
                                                                                        </Button>
                                                                                    )}
                                                                            </div>
                                                                        )}
                                                                    {/* {user?.userType == "OPTICIAN" && eyetest?.status == "Approved" && eyetest?.needPrescription == "Yes" && eyetest?.showPrescriptiontoOptician == "Yes" && (
                                                            <Button variant='light' onClick={() => navigate("/prescription", { state: { id: eyetest.testId } })}>
                                                                <Stack direction="horizontal" gap={1}>
                                                                    <File width={16} />
                                                                </Stack>
                                                            </Button>
                                                        )} */}
                                                                    <Button
                                                                        variant="light"
                                                                        onClick={() => {
                                                                            sessionStorage.setItem(
                                                                                'pageCount',
                                                                                JSON.stringify(
                                                                                    {
                                                                                        eyetest:
                                                                                            pageCount,
                                                                                        patient: 1,
                                                                                    }
                                                                                )
                                                                            );
                                                                            navigate(
                                                                                '/eyetest/view',
                                                                                {
                                                                                    state: {
                                                                                        id: eyetest.testId,
                                                                                        edit: false,
                                                                                        glass:
                                                                                            eyetest.testType ===
                                                                                                'EyeGlasses'
                                                                                                ? true
                                                                                                : false,
                                                                                    },
                                                                                }
                                                                            );
                                                                        }}
                                                                    >
                                                                        <Stack
                                                                            direction="horizontal"
                                                                            gap={
                                                                                1
                                                                            }
                                                                        >
                                                                            {/* <img src={view} width={16} /> */}
                                                                            <Eye
                                                                                width={
                                                                                    16
                                                                                }
                                                                            />
                                                                            {/* <span style={{ color: "#1D2939" }}>{t("view")}</span> */}
                                                                        </Stack>
                                                                    </Button>
                                                                    {[
                                                                        'BACKOFFICE',
                                                                        'ADMIN',
                                                                        'OPTICIAN',
                                                                    ].includes(
                                                                        user?.userType
                                                                    ) && (
                                                                            <Button
                                                                                variant="light"
                                                                                onClick={() => {
                                                                                    sessionStorage.setItem(
                                                                                        'pageCount',
                                                                                        JSON.stringify(
                                                                                            {
                                                                                                eyetest:
                                                                                                    pageCount,
                                                                                                patient: 1,
                                                                                            }
                                                                                        )
                                                                                    );
                                                                                    navigate(
                                                                                        '/eyetest/edit',
                                                                                        {
                                                                                            state: {
                                                                                                id: eyetest.testId,
                                                                                                edit: true,
                                                                                                glass:
                                                                                                    eyetest.testType ===
                                                                                                    'EyeGlasses',
                                                                                            },
                                                                                        }
                                                                                    );
                                                                                }}
                                                                                disabled={
                                                                                    (
                                                                                        user?.userType === 'BACKOFFICE'
                                                                                        // user?.userType === 'ADMIN'
                                                                                    ) &&
                                                                                    (
                                                                                        ['Approved', 'Not Approved'].includes(eyetest?.status)
                                                                                    )
                                                                                    ||
                                                                                    (
                                                                                        user?.userType === 'OPTICIAN' &&
                                                                                        eyetest?.assignedToDoc === 'Yes' &&
                                                                                        eyetest?.status == 'Approved'
                                                                                    )
                                                                                    ||
                                                                                    (
                                                                                        user?.userType === 'OPTICIAN' &&
                                                                                        eyetest?.assignedToDoc === 'Yes' &&
                                                                                        eyetest?.status == 'Not Approved'
                                                                                    )
                                                                                    ||
                                                                                    (
                                                                                        user?.userType === 'OPTICIAN' &&
                                                                                        eyetest?.status === 'Approved'
                                                                                    )
                                                                                    ||
                                                                                    (
                                                                                        user?.userType === 'OPTICIAN' &&
                                                                                        eyetest?.assignedToDoc === 'Yes'
                                                                                    )

                                                                                }
                                                                            >
                                                                                <Stack
                                                                                    direction="horizontal"
                                                                                    gap={
                                                                                        1
                                                                                    }
                                                                                >
                                                                                    <Pencil
                                                                                        width={
                                                                                            16
                                                                                        }
                                                                                    />
                                                                                </Stack>
                                                                            </Button>
                                                                        )}
                                                                    {[
                                                                        'ADMIN',
                                                                    ].includes(
                                                                        user?.userType
                                                                    ) && (
                                                                            <DeleteUser
                                                                                email={
                                                                                    eyetest.testId
                                                                                }
                                                                                setLoading={
                                                                                    setLoading
                                                                                }
                                                                                eyeTest={
                                                                                    true
                                                                                }
                                                                            />
                                                                        )}
                                                                </ButtonGroup>
                                                            </div>
                                                        </Stack>
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    )
                                ) : (
                                    <tr>
                                        <td colSpan={9}>
                                            <Stack
                                                gap={2}
                                                className="mt-5 mb-5 mx-auto text-center"
                                            >
                                                <Image
                                                    src={NoDraft}
                                                    width={88}
                                                    className="mx-auto"
                                                />
                                                <h4>{t('noDataAvailable')}</h4>
                                                {/* <p>{t("YouHaven'tCreatedAnyDraftYet")}</p> */}
                                            </Stack>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                    <Card.Footer>
                        <Stack direction="horizontal" gap={3}>
                            <div className="ms-auto">
                                <Stack direction="horizontal" gap={3}>
                                    {/* Page numbers */}
                                    <span>
                                        Page {pageCount} of{' '}
                                        {Math.ceil(
                                            eyetestData?.listData?.totalItems /
                                            eyetestListConfig.pageSize
                                        )}
                                    </span>

                                    {/* Showing data range */}
                                    <span>
                                        Affichage de{' '}
                                        {(pageCount - 1) *
                                            eyetestListConfig.pageSize +
                                            1}
                                        –
                                        {Math.min(
                                            pageCount *
                                            eyetestListConfig.pageSize,
                                            eyetestData?.listData?.totalItems
                                        )}{' '}
                                        of {eyetestData?.listData?.totalItems}
                                    </span>

                                    {/* Prev button */}
                                    <Button
                                        variant="secondary"
                                        className="paginationBar_rightSide_prev"
                                        disabled={pageCount === 1}
                                        onClick={() =>
                                            handleFilterChange(pageCount - 1)
                                        }
                                    >
                                        {t('prev')}
                                    </Button>

                                    {/* Next button */}
                                    <Button
                                        className="paginationBar_rightSide_next"
                                        disabled={
                                            pageCount ===
                                            Math.ceil(
                                                eyetestData?.listData
                                                    ?.totalItems /
                                                eyetestListConfig.pageSize
                                            )
                                        }
                                        onClick={() =>
                                            handleFilterChange(pageCount + 1)
                                        }
                                    >
                                        {t('next')}
                                    </Button>
                                </Stack>
                            </div>
                        </Stack>
                    </Card.Footer>
                </Card>
            </Container>
        </>
    );
};

export default EyetestList;
